import React from "react";
import { FiFileText, FiUploadCloud, FiFile, FiX, FiRefreshCw, FiChevronDown } from "react-icons/fi";

export default function DocumentsStep({
  NavigationButtons,
  selectedDocType,
  setSelectedDocType,
  documentTypes,
  fileInputRef,
  handleFileUpload,
  uploadedFiles,
  formatFileSize,
  handleRemoveFile,
  handleRefreshDocumentContent,
  handleClearDocumentContent,
  apiInProgress,
  showDocumentContent,
  documentRows,
  renderDocumentStyleSurface,
}) {
  return (
    <div className="wizard-step-content">
      <div className="step-header-with-nav">
        <div className="step-header-left">
          <div className="step-icon-wrapper">
            <FiFileText className="step-icon" />
          </div>
          <div className="step-header-text">
            <h2 className="step-title">Document Selection</h2>
            <p className="step-subtitle">Select document type and upload files for migration</p>
          </div>
        </div>
        <NavigationButtons />
      </div>

      <div className="form-section">
        <div className="document-upload-row">
          <div className="form-group document-control-group">
            <label className="form-label">Document Type</label>
            <div className="document-control-card">
              <div className="document-type-dropdown-wrapper">
                <select
                  className="document-type-dropdown"
                  value={selectedDocType}
                  onChange={(event) => setSelectedDocType(event.target.value)}
                >
                  <option value="">Select a document type...</option>
                  {documentTypes.map((documentType) => (
                    <option key={documentType.id} value={documentType.id}>
                      {documentType.name} - {documentType.description}
                    </option>
                  ))}
                </select>
                <FiChevronDown className="dropdown-icon" />
              </div>
            </div>
          </div>

          <div className="form-group document-control-group upload-control-group">
            <label className="form-label">Upload Documents</label>
            <div className="document-control-card">
              <div
                className="upload-area upload-area-compact"
                onClick={() => fileInputRef.current?.click()}
              >
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileUpload}
                  accept=".csv,.xlsx,.docx"
                  style={{ display: "none" }}
                />
                <FiUploadCloud className="upload-area-icon" />
                <h4>Drop files here or click to upload</h4>
                <p>Supports CSV, XLSX, DOCX</p>
              </div>

              {uploadedFiles.length > 0 && (
                <div className="uploaded-files">
                  <h4>Uploaded Files ({uploadedFiles.length})</h4>
                  <div className="file-list">
                    {uploadedFiles.map((file) => (
                      <div key={file.id} className="file-item">
                        <FiFile className="file-icon" />
                        <div className="file-info">
                          <span className="file-name">{file.name}</span>
                          <span className="file-size">{formatFileSize(file.size)}</span>
                        </div>
                        <button
                          className="file-remove"
                          onClick={() => handleRemoveFile(file.id)}
                          aria-label="Remove file"
                        >
                          <FiX />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="form-group document-content-group">
          <div className="document-content-actions">
            <button
              className="document-action-btn"
              onClick={handleRefreshDocumentContent}
              disabled={apiInProgress}
              type="button"
            >
              <FiRefreshCw /> Refresh Content
            </button>
            <button
              className="document-action-btn"
              onClick={handleClearDocumentContent}
              disabled={apiInProgress}
              type="button"
            >
              <FiX /> Clear Content
            </button>
          </div>

          {showDocumentContent && documentRows.length > 0 && renderDocumentStyleSurface(documentRows, "document-preview")}
        </div>
      </div>
    </div>
  );
}
